// extracted by mini-css-extract-plugin
export default {"section":"Qu-z","inSectionButton":"Ru-z","addressCard":"Su-z","disabled":"Tu-z","cautionBox":"Uu-z","failureBox":"Vu-z","fade-out":"Wu-z","successBox":"Xu-z"};